var _ellipse, _ellipse2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationChecklist = function SvgIllustrationChecklist(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-disabled)",
    viewBox: "0 0 57 55",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.7,
    cy: 38.5,
    fill: "var(--secondary-fill)",
    rx: 8.4,
    ry: 8.6,
    transform: "rotate(-90 38.7 38.5)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2,
    cy: 16.5,
    fill: "var(--secondary-fill)",
    rx: 8.4,
    ry: 8.6,
    transform: "rotate(-90 18.2 16.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m42.2 19 .7-5.7 5.9.7-.7 5.7zM8.3 42l1.3-5.6 5.8 1.3-1.3 5.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M29 14.9c-7.6 0-13.8 5.8-13.8 13S21.4 41 29 41c7.5 0 13.7-5.8 13.7-13S36.5 15 29 15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M23.9 33.1q-.4 0-.7-.2l-.2-.6v-8.7q0-.4.2-.7l.7-.2h10.4q.4 0 .6.2.3.3.3.7v8.7q0 .3-.3.6l-.6.2zm1-2.3h3v-1.1h-3zm5.7-1.1 3-3-.9-.7-2 2-1-.8-.8.8zM25 28.5h3v-1.2h-3zm0-2.3h3V25h-3z"
  })));
};
export default SvgIllustrationChecklist;